import type { AutoSuggestionState, SuggestionStatus } from '@rp/contracts'

const percent = (value: number): string => `${Math.round(value * 100)}%`

export const SUGGESTION_COPY = {
  title: 'AI 建議',
  request: '產生建議',
  retry: '重試',
  regenerate: '重新產生',
  pending: '建議生成中',
  grounding: '依據來源',
  groundingHint: '勾選要參考的來源，或直接採用其中一則的內容。',
  adopt: '採用',
  adopting: '取用中…',
  adoptFailed: '取不到這則來源的完整內容，請再試一次。',
  regenerateFromSelection: '用選取來源重新產生',
  similarityLabel: '相似度',
  confidence: '信心值',
  topSimilarity: (value: number) => `最高相似度 ${percent(value)}`,
  gateLabel: '知識庫依據',
  gate: (value: number) => `門檻 ${percent(value)}`,
  sourceKinds: { kb_source: '知識庫', corpus_entry: '核准回覆' },
  none: '尚未產生建議',
  waitingHints: {
    queued: 'AI 會自動為這則草擬建議。還沒出現的話，按「產生建議」自行產生。',
    manual: '按「產生建議」後，AI 會依知識庫與核准回覆草擬一份建議。',
    not_inbox: '這則不在收件匣，AI 不會自動草擬建議。需要的話仍可按「產生建議」自行產生。',
    unclassified: '這則還沒完成分類，AI 不會自動草擬建議。可在「重新分類」補上判斷，或自行產生。',
    out_of_domain: '這則被判定為業務範圍外，AI 不會自動草擬建議。需要的話仍可按「產生建議」自行產生。',
    suppressed_intent: '垃圾訊息、酸民與表情回應不會自動草擬建議。需要的話仍可按「產生建議」自行產生。',
  } satisfies Record<AutoSuggestionState, string>,
  states: {
    pending: '建議生成中',
    ready: '已有建議',
    no_confident: '沒有把握的建議',
    failed: '沒有建議 — AI 暫時無法使用',
    stale: '建議已過期',
  } satisfies Record<SuggestionStatus, string>,
  noConfidentHint: '知識庫沒有足夠資料支撐這個答案。請人手回覆，或在知識庫補充資料後按「重新產生」。',
  failedHint: '建議生成失敗，你仍然可以直接人手回覆。',
  budgetExhaustedState: '沒有建議 — 本月 AI 用量已達上限',
  budgetExhaustedHint: '本月的 AI 用量已用完，AI 暫停草擬建議，請直接人手回覆。管理員可在「用量」調整上限。',
  staleHint: '這份建議已過時：客人之後傳了新訊息，或所依據的知識庫來源已更新。請重新產生。',
  outdatedHint: '客人之後再傳了訊息或改了內容，這份建議未必回應最新一則。',
  adoptGone: '這則來源已從知識庫移除或更新，無法採用。請按「重新產生」取得新建議。',
  generatedAt: (time: string) => `產生於 ${time}`,
  provider: (provider: string, model: string) => `${provider} · ${model}`,
} as const
